import React from 'react';
import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import usePostData from '@/hooks/usePostData';
import { useHidePostActions } from "@/auth/hooks/useHidePostActions";

const ContactAdd = ({ open, setOpen, financer, handleCreate }) => {
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const { postData } = usePostData<any>();
  const hidePostActions = useHidePostActions();
  const [loadingAdd, setLoadingAdd] = useState(false);

  useEffect(() => {
    setFirstname("");
    setLastname("");
    setPhone("");
    setEmail("");
  }, [open]);

    if (hidePostActions) return null;
    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogContent className="max-w-[800px] w-[800px] min-w-[800px]">
                <div
                className="space-y-6"
                >
                <DialogHeader>
                    <DialogTitle className="text-2xl">
                        Ajouter un représentant
                    </DialogTitle>
                    <DialogDescription>
                        Renseigner les informations du representant.
                    </DialogDescription>
                </DialogHeader>

                <div className="grid grid-cols-2 gap-4">
                    <div className="flex flex-col">
                        <label className="text-sm font-medium text-gray-900">
                            Prénom <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            value={firstname}
                            onChange={(e) => setFirstname(e.target.value)}
                            className="mt-1 p-2 border border-gray-300 rounded-md"
                        />
                    </div>
                    <div className="flex flex-col">
                        <label className="text-sm font-medium text-gray-900">
                            Nom <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            value={lastname}
                            onChange={(e) => setLastname(e.target.value)}
                            className="mt-1 p-2 border border-gray-300 rounded-md"
                        />
                    </div>
                    <div className="flex flex-col">
                        <label className="text-sm font-medium text-gray-900">
                            Téléphone
                        </label>
                        <input
                            type="text"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                            className="mt-1 p-2 border border-gray-300 rounded-md"
                        />
                    </div>
                    <div className="flex flex-col">
                        <label className="text-sm font-medium text-gray-900">
                            Email
                        </label>
                        <input
                            type="text"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="mt-1 p-2 border border-gray-300 rounded-md"
                        />
                    </div>
                </div>

                <DialogFooter>
                    <Button type="button" onClick={async (e) => {
                            e.preventDefault();
                            setLoadingAdd(true);
                            const res = await postData({
                                url: `${import.meta.env.VITE_IP_API}/api/representant`,
                                    data: {
                                        firstname,
                                        lastname,
                                        phone,
                                        email,
                                        financer: financer
                                    },
                            });

                            if( res ) {
                                setLoadingAdd(false);
                                handleCreate(res);
                                setOpen(false);
                            }
                        }} disabled={loadingAdd}>
                        Sauvegarder
                    </Button>
                </DialogFooter>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default ContactAdd;
